export interface QuickReplyData {
  shortcut: string;
  message: string;
  id: string;
  accessTo?: string | null;
}

export enum MENU_ITEM_ID {
  ADD = 'add_quick_reply',
}

export interface MenuItem {
  id: string;
  title: string;
  value?: string;
}

export enum QuickReplyVisibility {
  ME = 'me',
  EVERYONE = 'everyone',
}

export enum QuickReplyMsgType {
  TEXT_OR_MEDIA = 'text_or_media',
  INTERACTIVE_REPLY_BUTTON = 'interactive_reply_button',
  INTERACTIVE_LIST = 'interactive_list',
  INTERACTIVE_CTA = 'interactive_cta',
}

export enum QuickReplyMsgTypeForAPI {
  TEXT = 'TEXT',
  MEDIA = 'MEDIA',
}

export interface MediaItem {
  id: string;
  url: string | null;
  file: File;
  type: 'photo' | 'video' | 'audio';
  caption?: string;
}

export type TextQuickReplyDataType = {
  text: string;
};

export enum QRAllowedMediaTypes {
  IMAGE = 'image',
  VIDEO = 'video',
  AUDIO = 'audio',
  DOCUMENT = 'document',
}
export type TextOrMediaItemMediaItemType = {
  messageType: QRAllowedMediaTypes;
  fileUrl: string;
  fileName: string;
  fileType: string;
  size: number;
  height: number;
  width: number;
  thumbnailUrl?: string;
  text?: string;
};
export type TextOrMediaItemDataType = {
  mediaItems?: TextOrMediaItemMediaItemType[];
  text?: string;
};

export type MediaQuickReply = {
  mediaItems: MediaItem[];
};

export type MeidaUploadWithOptions = {
  type: 'text' | 'image' | 'video' | 'document';
  text?: string;
  fileUrl?: string;
  thumbnailUrl?: string;
  fileType?: string;
  fileName?: string;
  size?: number;
};

export type MessageDbInteractiveList = {
  header?: MeidaUploadWithOptions;
  body: {
    text: string;
  };
  button: string;
  footer?: {
    text: string;
  };
  sections: Array<{
    title: string;
    rows: Array<{
      title: string;
      id: string;
      description?: string;
    }>;
  }>;
};

export enum InteractiveReplyBtnHeaderTypes {
  NONE = 'none',
  TEXT = 'text',
  IMAGE = 'image',
  MEDIA = 'media',
  VIDEO = 'video',
  DOCUMENT = 'document',
}
export interface MessageDbMediaBase {
  fileUrl: string;
  text?: string;
  size: number;
}

export type MessageDbImage = MessageDbMediaBase & {
  fileType?: 'image';
  height: number;
  width: number;
  thumbnailUrl: string;
};

export type MessageDbVideo = MessageDbMediaBase & {
  fileType: 'video';
  thumbnailUrl: string;
  duration: number;
  height: number;
  width: number;
};
export type MessageDbDocumentPdf = {
  fileType: 'pdf';
  pageCount: number;
  isPasswordProtected?: boolean;
  thumbnailUrl: string;
};

// export type MessageDbDocument = MessageDbMediaBase & {
//   messageType: InteractiveReplyBtnHeaderTypes.DOCUMENT;
//   fileName?: string;
// } & (
//     | {
//         fileType: Exclude<MessageFileType, MessageDbDocumentPdf['fileType']>;
//       }
//     | MessageDbDocumentPdf
//   );

export type MessageDbInteractiveHeaderMedia =
  | ({ type: InteractiveReplyBtnHeaderTypes.IMAGE } & MessageDbImage)
  | ({ type: InteractiveReplyBtnHeaderTypes.VIDEO } & MessageDbVideo);
// | ({ type: InteractiveReplyBtnHeaderTypes.DOCUMENT } & Omit<
//     MessageDbDocument,
//     'text' | 'messageType'
//   >);

export type MessageDbInteractiveHeaderText = {
  type: InteractiveReplyBtnHeaderTypes.TEXT;
  text: string;
};

export type QRInteractiveReplyButtonsType = {
  // header?: MessageDbInteractiveHeaderText | MessageDbInteractiveHeaderMedia;
  footer?: {
    text: string;
  };
  header?: MeidaUploadWithOptions;
  body: {
    text: string;
  };
  buttons: Array<{
    title: string;
    id: string;
  }>;
};

export type QuickReplyAtomTypeForTextOrMediaType = TextOrMediaItemDataType | null;
export type QuickReplyInteractiveMsgsType = QRInteractiveReplyButtonsType | MessageDbInteractiveList;
export enum QuickReplyInteractiveMsgsVariantsType {
  BUTTON = 'button',
  LIST = 'list',
}
export enum QuicReplyRawMsgType {
  TEXT = 'text',
  MEDIA = 'media',
  INTERACTIVE = 'interactive',
  LIST = 'list',
}

export type QuickReplyV2Payload = {
  shortcut: string;
  id: string;
  rawMessage: {
    messageType: QuicReplyRawMsgType;
    text?: string;
    mediaItems?: TextOrMediaItemMediaItemType[];
    interactiveMessage?: {
      type: QuickReplyInteractiveMsgsVariantsType;
    } & QuickReplyInteractiveMsgsType;
  };
  accessTo: QuickReplyVisibility;
};

export type QuickReplyV2DataPaginatedArgs = {
  hasMore: boolean;
  lastQuickReplyDate: string;
  lastQuickReplyId: string;
};

export type QuickReplyV2DataResponse = {
  replies: QuickReplyV2Payload[];
  paginationOptions: QuickReplyV2DataPaginatedArgs;
};
